import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';

const Register = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [roles, setRoles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Carica i ruoli dal backend
  useEffect(() => {
    const token = localStorage.getItem('token')?.trim();
    axios.get('http://localhost:8080/roles/all',{
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        setRoles(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching roles!", error);
      });
  }, []);

  // Funzione per inviare i dati del modulo
  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const userData = {
      username: data.username,
      password: data.password,
      role: {
        id: data.role.id,      // L'oggetto completo del ruolo
        name: data.role.name   // L'oggetto completo del ruolo
      }
    };

    try {
      const response = await axios.post('/auth/register', userData);
      console.log("User registered:", response.data);
      // Gestisci il successo (per esempio, mostra un messaggio o fai il redirect)
    } catch (error) {
      console.error("There was an error registering the user", error);
      // Gestisci l'errore
    }
    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <label htmlFor="username">Username</label>
        <input
          id="username" autoComplete="username" type="text"
          {...register("username", { required: "Username is required" })}
        />
        {errors.username && <p>{errors.username.message}</p>}
      </div>

      <div>
        <label htmlFor="password">Password</label>
        <input
          id="password" type="password" autoComplete="current-password"
          {...register("password", { required: "Password is required" })}
        />
        {errors.password && <p>{errors.password.message}</p>}
      </div>

      <div>
        <label htmlFor="role">Role</label>
        <select
          id="role"
          {...register("role", { required: "Role is required" })}
        >
          <option value="">Select a role</option>
          {roles.map(role => (
            <option key={role.id} value={JSON.stringify(role)}>{role.name}</option>
          ))}
        </select>
        {errors.role && <p>{errors.role.message}</p>}
      </div>

      <button type="submit" disabled={isSubmitting}>Register</button>
    </form>
  );
};

export default Register;